import React, { Component } from 'react';
import { gsap } from 'gsap';
import './style.css';

const SIMPLE = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97]
const sampleNumber = () => {

    return SIMPLE[Math.floor((Math.random() - 0.0000005) * SIMPLE.length)];
}


export default class NgGameRPGSnowman extends Component {

    state = {
    }

    splitReverse = false;

    headConstruct = ({ snowman, width3, height1, width1 }) => {
        let Head = null;
        const { headType } = snowman;

        if (headType === 'usual') {
            Head = <div className='ngg_snowman_usual_head' style={{ left: width3 / 2, top: height1 * 1.1, width: width1, height: height1 }}>
                <div className='ngg_snowman_usual_backet' style={{ width: width1 * 0.6, top: -height1 * 0.8, left: -width1 * 0.2 }}>
                    <img src='/../images/ver2/snowman/snowman/backet1.png' style={{ width: width1 * 0.6, height: 'auto' }} />
                </div>
                <div className='ngg_snowman_usual_ball' style={{ width: width1, height: height1 }}>
                    <img id={`div_body_snow_point_1`} src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: width1, height: height1 }} />
                </div>
                <div className='ngg_snowman_usual_face' style={{ width: width1 * 0.37, height: height1, top: -height1 * 0.17, left: -width1 * 0.43 }}>
                    <img src='/../images/ver2/snowman/snowman/face1.png' style={{ width: width1 * 0.37, height: 'auto' }} />
                </div>
            </div>
        }
        if (headType === 'cup') {
            Head = <div className='ngg_snowman_usual_head' style={{ left: width3 / 2, top: height1 * 1.1, width: width1, height: height1 }}>
                <div className='ngg_snowman_usual_backet' style={{ width: width1 * 0.6, top: -height1 * 0.8, left: -width1 * 0.2 }}>
                    <img src='/../images/ver2/snowman/snowman/cup1.png' style={{ width: width1 * 0.6, height: 'auto' }} />
                </div>
                <div className='ngg_snowman_usual_ball' style={{ width: width1, height: height1 }}>
                    <img id={`div_body_snow_point_1`} src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: width1, height: height1 }} />
                </div>
                <div className='ngg_snowman_usual_face' style={{ width: width1 * 0.37, height: height1, top: -height1 * 0.17, left: -width1 * 0.43 }}>
                    <img src='/../images/ver2/snowman/snowman/face1.png' style={{ width: width1 * 0.37, height: 'auto' }} />
                </div>
            </div>
        }

        if (headType === 'flash') {
            Head = <div className='ngg_snowman_usual_head' style={{ left: width3 / 2, top: height1 * 1.1, width: width1, height: height1 }}>
                <div className='ngg_snowman_usual_ball' style={{ width: width1, height: height1 }}>
                    <img id={`div_body_snow_point_1`} src='/../images/ver2/snowman/snowman/part_flash_head.png' style={{ width: width1, height: height1 }} />
                </div>
                <div className='ngg_snowman_usual_face' style={{ width: width1 * 0.37, height: height1, top: -height1 * 0.17, left: -width1 * 0.43 }}>
                    <img src='/../images/ver2/snowman/snowman/face1.png' style={{ width: width1 * 0.37, height: 'auto' }} />
                </div>
            </div>
        }
        if (headType === 'math') {
            Head = <div className='ngg_snowman_usual_head' style={{ left: width3 / 2, top: height1 * 1.1, width: width1, height: height1 }}>
                <div className='ngg_snowman_usual_ball' style={{ width: width1, height: height1 }}>
                    <img id={`div_body_snow_point_1`} src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: width1, height: height1 }} />
                </div>
                <div className='ngg_snowman_usual_face' style={{ width: width1 * 0.37, height: height1, top: -height1 * 0.17, left: -width1 * 0.43 }}>
                    <img src='/../images/ver2/snowman/snowman/face_math.png' style={{ width: width1 * 0.37, height: 'auto' }} />
                </div>
            </div>
        }
        if (headType === 'spices') {
            Head = <div className='ngg_snowman_usual_head' style={{ left: width3 / 2, top: height1 * 1.1, width: width1, height: height1 }}>
                <div className='ngg_snowman_usual_ball' style={{ width: width1, height: height1 }}>
                    <img id={`div_body_snow_point_1`} src='/../images/ver2/snowman/snowman/part_spices.png' style={{ width: width1, height: height1 }} />
                </div>
                <div className='ngg_snowman_usual_face' style={{ width: width1 * 0.67, height: height1, top: -height1 * 0.17, left: -width1 * 0.63 }}>
                    <img src='/../images/ver2/snowman/snowman/face_spices.png' style={{ width: width1 * 0.67, height: 'auto' }} />
                </div>
            </div>
        }
        if (headType === 'gigo') {
            Head = <div className='ngg_snowman_usual_head' style={{ left: width3 * 0.55, top: height1 * 0.9, width: width1 * 0.7, height: height1 * 0.7 }}>
                <div className='ngg_snowman_usual_ball' style={{ width: width1, height: height1 }}>
                    <img id={`div_body_snow_point_1`} src='/../images/ver2/snowman/snowman/part_gigo_head.png' style={{ width: width1 * 0.7, height: height1 * 0.7 }} />
                </div>
                <div className='ngg_snowman_usual_face' style={{ width: width1 * 0.26, height: height1, top: -height1 * 0.17, left: -width1 * 0.33 }}>
                    <img src='/../images/ver2/snowman/snowman/face_gigo.png' style={{ width: width1 * 0.2, height: 'auto' }} />
                </div>
            </div>
        }
        return Head;
    }

    bodyMiddleConstruct = ({ snowman, width3, height, width2, height2 }) => {
        let BodyMiddle = null;
        const { armorType } = snowman;
        if (!armorType || !armorType[2]) return BodyMiddle;

        const { material, uppers } = armorType[2];

        let Uppers = null;

        if (uppers && uppers.length) {
            for (let i = 0; i < uppers.length; i++) {
                const { type, armorName } = uppers[i];
                if (type === 'shield') {
                    Uppers = <div className='ngg_snowman_usual_ball ngg_snowman_usual_body' style={{ left: width3 * 0.35, top: height * 0.52, width: width2 * 1.3, height: height2 }}>
                        <img id={`div_body_armor_${armorName}`} src={`/../images/ver2/snowman/snowman/armor_${armorName}_1.png`} style={{ width: width2 * 0.9, height: 'auto' }} />
                    </div>
                }
            }
        }

        if (material === 'snow') {
            BodyMiddle = <div className='ngg_snowman_usual_ball ngg_snowman_usual_body' style={{ left: width3 / 2, top: height * 0.55, width: width2, height: height2 }}>
                <img id={`div_body_snow_point_2`} src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: width2, height: height2 }} />
            </div>
        }
        if (material === 'flash') {
            BodyMiddle = <div className='ngg_snowman_usual_ball ngg_snowman_usual_body' style={{ left: width3 / 2, top: height * 0.55, width: width2, height: height2 }}>
                <img id={`div_body_snow_point_2`} src='/../images/ver2/snowman/snowman/part_flash.png' style={{ width: width2, height: height2 }} />
            </div>
        }
        if (material === 'spices') {
            BodyMiddle = <div className='ngg_snowman_usual_ball ngg_snowman_usual_body' style={{ left: width3 / 2, top: height * 0.55, width: width2, height: height2 }}>
                <img id={`div_body_snow_point_2`} src='/../images/ver2/snowman/snowman/part_spices.png' style={{ width: width2, height: height2 }} />
            </div>
        }
        if (material === 'gigo') {
            BodyMiddle = <div className='ngg_snowman_usual_ball ngg_snowman_usual_body' style={{ left: width3 * 0.45, top: height * 0.52, width: width2 * 1.3, height: height2 }}>
                <img id={`div_body_snow_point_2`} src='/../images/ver2/snowman/snowman/part_gigo_middle.png' style={{ width: width2 * 1.3, height: 'auto' }} />
            </div>
        }
        return [BodyMiddle, Uppers];
    }

    bodyBottomConstruct = ({ snowman, width3, height, height3 }) => {
        let BodyBottom = null;
        const { armorType } = snowman;
        if (!armorType || !armorType[3]) return BodyBottom;

        const { material } = armorType[3];
        if (material === 'snow') {
            BodyBottom = <div className='ngg_snowman_usual_ball ngg_snowman_usual_bottom' style={{ left: width3 / 2, top: height - height3 / 2, width: width3, height: height3 }}>
                <img id={`div_body_snow_point_3`} src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: width3, height: height3 }} />
            </div>
        }
        if (material === 'spices') {
            BodyBottom = <div className='ngg_snowman_usual_ball ngg_snowman_usual_bottom' style={{ left: width3 / 2, top: height - height3 / 2, width: width3, height: height3 }}>
                <img id={`div_body_snow_point_3`} src='/../images/ver2/snowman/snowman/part_spices.png' style={{ width: width3, height: height3 }} />
            </div>
        }
        if (material === 'gigo') {
            BodyBottom = <div className='ngg_snowman_usual_ball ngg_snowman_usual_bottom' style={{ left: width3 / 2, top: height - height3 / 2, width: width3 * 0.7, height: height3 }}>
                <img id={`div_body_snow_point_3`} src='/../images/ver2/snowman/snowman/part_gigo_bottom.png' style={{ width: width3 * 0.7, height: height3 }} />
            </div>
        }
        return BodyBottom;
    }

    hitConstruct = ({ snowman, width3, height, widthHit, heightHit }) => {
        let Hit = null;
        const { attackView } = snowman;

        if (attackView === 'snow') {
            Hit = [
                <div className='ngg_snowman_usual_hit ngg_snowman_usual_hit_1' key={'ngsnh_1'} style={{ left: width3, top: height * 0.55, width: widthHit, height: heightHit }}>
                    <div className='ngg_snowman_usual_ball' style={{ width: widthHit, height: heightHit }}>
                        <img src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: widthHit, height: heightHit }} />
                    </div>
                </div>,
                <div className='ngg_snowman_usual_hit ngg_snowman_usual_hit_2' key={'ngsnh_2'} style={{ left: width3, top: height * 0.55, width: widthHit, height: heightHit, opacity: 0 }}>
                    <div className='ngg_snowman_usual_ball' style={{ width: widthHit, height: heightHit }}>
                        <img src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: widthHit, height: heightHit }} />
                    </div>
                </div>,
                <div className='ngg_snowman_usual_hit ngg_snowman_usual_hit_3' key={'ngsnh_3'} style={{ left: width3, top: height * 0.55, width: widthHit, height: heightHit, opacity: 0 }}>
                    <div className='ngg_snowman_usual_ball' style={{ width: widthHit, height: heightHit }}>
                        <img src='/../images/ver2/snowman/snowman/part_snow.png' style={{ width: widthHit, height: heightHit }} />
                    </div>
                </div>,
            ]
        }
        if (attackView === 'math') {
            Hit = <div className='ngg_snowman_usual_hit' style={{ left: width3, top: height * 0.55, width: widthHit, height: heightHit }}>
                <div className='ngg_snowman_usual_ball' style={{ width: widthHit, height: heightHit }}>
                    <img src='/../images/ver2/snowman/snowman/fist_math.png' style={{ width: widthHit, height: 'auto' }} />
                </div>
                <div className='ngg_snowman_usual_mathnumber' id={'ngg_snowman_usual_mathnumber'} style={{ fontSize: widthHit * 0.9 }}>
                    122
                </div>
            </div>
        }
        if (attackView === 'gigo') {
            Hit = [
                <div className='ngg_snowman_usual_hit ngg_snowman_usual_hit_1' id={'gigo_hand'} key={'ngsnh_1'} style={{ left: width3, top: height * 0.55, width: widthHit * 1.3, height: heightHit * 1.3 }}>
                    <div className='ngg_snowman_usual_ball' style={{ width: widthHit * 1.3, height: heightHit * 1.3 }}>
                        <img src='/../images/ver2/snowman/snowman/part_gigo_hand.png' style={{ width: widthHit * 1.3, height: 'auto' }} />
                    </div>
                </div>
            ]
        }
        return Hit;

    }

    /*
        const {
            attackStrategy, //: 'random',
            attackType, // 'snow', // как выглядит
            headType, // 'usual',
            armorType  {
                1: { type: 'usual' },
                2: { type: 'usual' },
                3: { type: 'usual' }
            },
        } = snowman;
    */

    constructor(props) {
        super();
        const { snowman, height, top, left } = props;

        const koef = 347 / 300; // x / y

        const height3 = height * 0.4;
        const width3 = height3 * koef;

        const height2 = height * 0.35;
        const width2 = height2 * koef;

        const height1 = height * 0.3;
        const width1 = height1 * koef;

        const heightHit = height * 0.15;
        const widthHit = heightHit * koef;

        let Hit = null;
        let Head = null;
        let BodyMiddle = null;
        let BodyBottom = null;

        Head = this.headConstruct({ snowman, width3, height1, width1 });
        BodyMiddle = this.bodyMiddleConstruct({ snowman, width3, height, width2, height2 })
        BodyBottom = this.bodyBottomConstruct({ snowman, width3, height, height3 })
        Hit = this.hitConstruct({ snowman, width3, height, widthHit, heightHit });

        this.Enemy = <div className='ngg_snowman_type_usual'>
            {BodyBottom}
            {BodyMiddle}
            {Head}
            {Hit}
        </div>

    }

    mainTimer = null;

    componentDidMount() {
        this.setUsualAnimation();
    }

    componentDidUpdate = (prevProps, { animations, animHash }) => {
    }

    setUsualAnimation = () => {
        gsap.killTweensOf('.ngg_snowman_usual_hit');
        gsap.fromTo('.ngg_snowman_usual_hit', { translateY: '-10%' }, {
            translateY: '10%',
            translateX: 0,
            repeat: -1,
            yoyo: true
        }
        )
        gsap.to('.ngg_snowman_usual_hit_2', {
            opacity: 0
        }
        )
        gsap.to('.ngg_snowman_usual_hit_3', {
            opacity: 0
        }
        )

        const { snowman: { attackType } } = this.props;
        if (attackType === 'math') {
            gsap.to('#ngg_snowman_usual_mathnumber', {
                opacity: 0,
                repeat: 0,
                duration: 0.2,
                yoyo: false
            }
            )
        }
    }

    setPrepareAnimation = ({ point, subtype }) => {
        const { snowman: { attackType } } = this.props;
        if (attackType === 'snow') {

            if (subtype === 'split') {
                gsap.killTweensOf('.ngg_snowman_usual_hit');
                gsap.to('.ngg_snowman_usual_hit_1', {
                    translateY: '-60%',
                    repeat: 0,
                    opacity: 1,
                    duration: 0.2,
                })
                gsap.to('.ngg_snowman_usual_hit_2', {
                    translateY: '60%',
                    repeat: 0,
                    opacity: 1,
                    duration: 0.2,
                })
            }

            gsap.to('.ngg_snowman_usual_hit', {
                translateX: '-50%',
                repeat: 1,
                duration: 0.2,
                yoyo: true
            })
        }


        if (attackType === 'math') {

            const sp1 = document.createElement("div")
            sp1.id = "ngg_snowman_usual_mathnumber";
            sp1.className = "ngg_snowman_usual_mathnumber";
            let number = 0;
            if (point === 1) number = sampleNumber();
            if (point === 2) number = (1 + Math.floor(Math.random() * 32)) * 3;
            if (point === 3) {
                number = null;
                while (!number) {
                    number = (1 + Math.floor(Math.random() * 32)) * 3;
                    number--;
                    if (SIMPLE.find(x => x === number)) {
                        number = null;
                    }
                }
            }

            const sp1_content = document.createTextNode(`${number}`);

            // Apply that content to the new element
            sp1.appendChild(sp1_content);

            const numb_node = document.getElementById('ngg_snowman_usual_mathnumber');

            const heightHit = this.props.height * 0.15;
            const koef = 347 / 300; // x / y
            const widthHit = heightHit * koef;

            sp1.style.fontSize = `${widthHit * 0.9}px`;


            const parentDiv = numb_node.parentNode;
            parentDiv.replaceChild(sp1, numb_node);

            gsap.to('#ngg_snowman_usual_mathnumber', {
                opacity: 1,
                repeat: 0
            }
            )
        }
    }

    setAimAnimation = ({ point, subtype }) => {
        const { snowman: { attackType } } = this.props;
        const ROTATE_BY_POINT = {
            1: 30,
            2: 0,
            3: -30
        }

        if (attackType === 'snow') {

            if (point === 4) {

                const { arena } = this.props;
                const { width, height } = arena;

                const { settings = {} } = this.props;
                const { cicleTime = 75 } = settings;

                let translateX = `-${width * 0.3}px`;
                let translateY = `-${height * 0.25}px`;

                gsap.killTweensOf('.ngg_snowman_usual_hit');
                gsap.to('.ngg_snowman_usual_hit', {
                    rotate: 0,
                    translateX,
                    translateY,
                    repeat: 0,
                    duration: 0.3
                }
                )
                return;
            }


            if (subtype === 'split') {
                this.splitReverse = Math.floor(Math.random() * 1.999);
                let point1 = 1;
                let point2 = 1;
                if (point === 1) { point1 = 2; point2 = 3 }
                if (point === 2) { point1 = 1; point2 = 3 }
                if (point === 3) { point1 = 1; point2 = 2 }

                gsap.to('.ngg_snowman_usual_hit_1', {
                    rotate: ROTATE_BY_POINT[this.splitReverse ? point1 : point2] || 0,
                    repeat: 0,
                    duration: 0.2,
                    yoyo: true
                }
                )
                gsap.to('.ngg_snowman_usual_hit_2', {
                    rotate: ROTATE_BY_POINT[this.splitReverse ? point2 : point1] || 0,
                    repeat: 0,
                    duration: 0.2,
                    yoyo: true
                }
                )
                return;
            }

            gsap.to('.ngg_snowman_usual_hit', {
                rotate: ROTATE_BY_POINT[point] || 0,
                repeat: 0,
                duration: 0.2,
                yoyo: true
            }
            )

        }
    }

    // анимация удара
    setHitAnimation = ({ point, subtype }) => {


        const { arena } = this.props;
        const { width, height } = arena;

        const { settings = {} } = this.props;
        const { cicleTime = 75 } = settings;

        let translateX = `-${width * 0.3}px`;

        if (point === 4) {
            gsap.to('.ngg_snowman_usual_hit', {
                translateY: `-${height * 0.35}px`,
                translateX,
                repeat: 0,
                duration: cicleTime * 5 / 1000,
                onComplete: () => {
                    gsap.to('.ngg_snowman_usual_hit', {
                        translateY: `${height * 0.15}px`,
                        translateX,
                        repeat: 0,
                        duration: cicleTime * 3 / 1000,
                        onComplete: () => {

                            let element = document.getElementById('gigo_hand');
                            if (element) {
                                const rect = element.getBoundingClientRect();
                                !!rect && this.props.addEffectAnimation({ action: 'gigo_strike', y: rect.top })
                            }

                            gsap.to('.ngg_snowman_usual_hit', {
                                translateY: '-10%',
                                translateX: 0,
                                repeat: 0,
                                duration: cicleTime * 3 / 1000,
                                delay: cicleTime * 2 / 1000,
                                onComplete: this.setUsualAnimation
                            }
                            )
                        }
                    }
                    )
                }
            }
            )
            return;
        }

        const TRANSLATEY_BY_POINT = {
            1: `-${height * 0.17}px`,
            2: `${height * 0.2 * 0.2}px`,
            3: `${height * 0.15}px`
        }

        if (subtype === 'split') {
            let point1 = 1;
            let point2 = 1;
            if (point === 1) { point1 = 2; point2 = 3 }
            if (point === 2) { point1 = 1; point2 = 3 }
            if (point === 3) { point1 = 1; point2 = 2 }

            gsap.to('.ngg_snowman_usual_hit_1', {
                translateX,
                translateY: TRANSLATEY_BY_POINT[this.splitReverse ? point1 : point2] || 0,
                repeat: 1,
                duration: cicleTime * 5 / 1000,
                yoyo: true
            }
            )
            gsap.to('.ngg_snowman_usual_hit_2', {
                translateX,
                translateY: TRANSLATEY_BY_POINT[this.splitReverse ? point2 : point1] || 0,
                repeat: 1,
                duration: cicleTime * 5 / 1000,
                yoyo: true,
                onComplete: this.setUsualAnimation
            }
            )
            return;
        }

        gsap.to('.ngg_snowman_usual_hit', {
            translateX,
            translateY: TRANSLATEY_BY_POINT[point] || `0px`,
            repeat: 1,
            duration: cicleTime * 5 / 1000,
            yoyo: true,
            onComplete: this.setUsualAnimation
        }
        )
    }

    // анимация баффов 
    setBuffAnimation = (props) => {
        const { buff } = props;
        if (!buff || !buff.type) return;

        switch (buff.type) {
            case 'sn_speed': {
                gsap.fromTo('.ngg_snowman_type_usual', { filter: `drop-shadow( 0px 0px 8px yellow )` }, {
                    filter: `drop-shadow( 0px 0px 8px #ff000000 )`,
                    duration: 3
                }
                )
                break;
            }
            case 'sn_spices': {
                this.props.addEffectAnimation(props);
                break;
            }
            default: { }
        }

    }


    setHittedAnimation = (props = {}) => {
        const { point } = props;

        let target = 'bbb';
        if (point === 1) target = '.ngg_snowman_usual_head';
        if (point === 2) target = '.ngg_snowman_usual_body';
        if (point === 3) target = '.ngg_snowman_usual_bottom';

        gsap.to(target, {
            translateX: '3%',
            repeat: 6,
            duration: 0.08,
            yoyo: true,
            onComplete: () => {
                gsap.to(target,
                    {
                        translateX: '0%',
                        duration: 0.08
                    }
                )
            }
        }
        )
    }

    setArmorHittedAnimation = (props) => {
        const { event } = props;
        if (!event) return;

        const { hp, innerHp, armorName } = event;

        const target = `#div_body_armor_${armorName}`;

        gsap.to(target, {
            translateX: '3%',
            repeat: 6,
            duration: 0.08,
            yoyo: true,
            onComplete: () => {
                gsap.to(target,
                    {
                        translateX: '0%',
                        duration: 0.08
                    }
                )
            }
        }
        )

        if (hp <= (innerHp / 2)) {
            let ball = document.getElementById(`div_body_armor_${armorName}`);
            if (ball) ball.src = `/../images/ver2/snowman/snowman/armor_${armorName}_2.png`;
        }
    }

    setArmorDestroyedAnimation = (props) => {
        const { event, point } = props;
        if (!event) return;
        const { armorName } = event;

        let ball = document.getElementById(`div_body_armor_${armorName}`);
        if (ball) ball.style.opacity = 0;
    }

    // point event type
    setDeflectHittedAnimation = (props) => {
        const { event, point } = props;
        if (!event) return;

        const { hp, innerHp } = event;
        if (hp <= (innerHp / 2)) {

            const { snowman } = this.props;
            const { armorType } = snowman;
            if (!armorType || !armorType[point]) return null;
            const { material } = armorType[point];
            let ball = document.getElementById(`div_body_${material}_point_${point}`);
            if (ball) ball.src = `/../images/ver2/snowman/snowman/part_snow_deflect_1.png`;
        }

    }
    // point event type
    setDeflectDestroyedAnimation = (props) => {
        const { event, point } = props;
        if (!event) return;

        const { snowman } = this.props;
        const { armorType } = snowman;
        if (!armorType || !armorType[point]) return null;
        const { material } = armorType[point];
        let ball = document.getElementById(`div_body_${material}_point_${point}`);
        if (ball) ball.src = `/../images/ver2/snowman/snowman/part_snow_deflect_2.png`;
    }


    // тут навреное должно быть в зависимости от типа снеговика вообще то
    addAnimation = (props) => {

        const { type, point, subtype } = props;
        if (type === 'show95' && point) {
            this.setPrepareAnimation({ point, subtype });
        }
        if (type === 'show80' && point) {
            this.setAimAnimation({ point, subtype });
        }
        if (type === 'strike' && point) {
            this.setHitAnimation({ point, subtype });
        }

        if (type === 'hitted' && point) {
            this.setHittedAnimation(props);
        }
        if (type === 'deflectHitted' && point) {
            this.setDeflectHittedAnimation(props);
        }
        if (type === 'deflectDestroyed' && point) {
            this.setDeflectDestroyedAnimation(props);
        }
        if (type === 'armorHitted' && point) {
            this.setArmorHittedAnimation(props);
        }
        if (type === 'armorDestroyed' && point) {
            this.setArmorDestroyedAnimation(props);
        }

        if (type === 'buffAdded') {
            this.setBuffAnimation(props);
        }
        // if (type === 'show75' && point) {
        //     this.setShow75Animation({ point });
        // }
        // if (type === 'show99' && point) {
        //     this.setShow99Animation({ point });
        // }
    }

    render() {
        const { height, top, left, zIndex } = this.props;

        return <div className='ngg_snowman_main' style={{ height, top, left, zIndex }} >
            <div className='ngg_snowman_inner' style={{ height }}>
                {!!this.Enemy && this.Enemy}
            </div>
        </div>
    }

}